import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  user: any;
}

const initialState: UserState = {
  user: null,
};

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = UserSlice.actions;
export default UserSlice.reducer;
